export const DEPENDENT_STATUS = {
  ME: 'ME',
  DEPENDENT: 'DEPENDENT',
};

export const NEW_USER_SESSION_STORAGE_KEY = 'newUserSession';

export const EVENTS_QUEUE_SESSION_STORAGE_KEY = 'eventsQueue';
